import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { ReactNode } from "react";
import styled from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            <div className="skip-links">
                <a href="#main-content-skip" className="skip-link">Skip to main content</a>
                <a href="#nav-skip" className="skip-link">Skip to navigation</a>
                <a href="#footer-skip" className="skip-link">Skip to footer</a>
            </div>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div">
                    <PageBreadcrumbs />
                </Page>
            )}
            <span id="main-content-skip"></span>
            {pageContent}
            <span id="footer-skip"></span>
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    .skip-link {
        position: absolute;
        top: -40px; 
        left: 6px; 
        background: #000; 
        color: #fff; 
        padding: 8px 12px; 
        text-decoration: none; 
        border-radius: 0 0 4px 4px; 
        font-size: 14px; 
        font-weight: bold; 
        z-index: 1000; 
        transition: top 0.3s; 
    } 
    .skip-link:focus { 
        top: 0; 
        outline: 2px solid #fff; 
        outline-offset: 2px; 
    } 
    .skip-link:hover { background: #333; } 
    .skip-links { 
        position: relative; 
        z-index: 1001; 
    }     
    span#nav-skip,
    span#main-content-skip,
    span#footer-skip {height:0;line-height:0;}
    
    @media (min-width: 768px) {    
        .skip-links .skip-link:nth-of-type(2) { left: 170px;} 
        .skip-links .skip-link:nth-of-type(3) { left: 317px;}
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;